const reflinks = {
  reflinks: 'Reflinks del administrador',
  showing: 'mostrando',
  reflinksOf: 'Reflinks de',
  noReflinksFound: 'No se encontraron reflinks',
  addNew: 'Añadir nuevo',
  tableDropdown: {
    quickActions: 'Acciones rápidas',
    fresh: 'Actualizar',
    exportReflinks: 'Exportar',
  },
  actionsDropdown: {
    update: 'Actualizar',
    delete: 'Eliminar',
  },
  modal: {
    addNewReflink: 'Añadir nuevo reflink',
    email: 'Correo electrónico',
    name: 'Nombre',
    code: 'Código',
    category: 'Categoría',
    bonus: 'Bonus',
    editReflink: 'Editar reflink',
  },
  messages: {
    success: 'Se ha creado un nuevo reflink',
    updateSuccess: 'Los enlaces de referencia se han guardado',
    deleteSuccess: 'Los enlaces de referencia se han eliminado',
  }
};

export default reflinks;
